const WorkerStates = {
    BOOTSTRAP: 'BOOTSTRAP',
    LOAD: 'LOAD',
    USER_CODE: 'USER_CODE'
}

module.exports = {
    WorkerStates
}
